module.exports = __webpack_public_path__ + "media/ask/female-front-b05aa01e.svg";